// AOS Animations
import AOS from 'aos';
AOS.init({
    offset: ( window.screen.width > 768 ) ? 150 : 50,
    duration: 500,
    delay: 50,
    once: true
});

// Other
import "/src/style/main.scss"

// Modules
import Navigation from './scripts/modules/navigation'
Navigation().init()

import Slider from "./scripts/modules/slider";
Slider().init()

import Accordions from "./scripts/modules/accordions";
Accordions().init()

import SmoothAnchor from "./scripts/modules/smooth-anchor";
SmoothAnchor().init()

import SiteHeader from "./scripts/modules/site-header";
SiteHeader().init()

import NewsFilter from "./scripts/modules/news-filters";
NewsFilter().init()